(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5093,9047,8691],{

/***/ 46259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ scrollToBottomHeader; }
/* harmony export */ });
var scrollToBottomHeader = function scrollToBottomHeader(el) {
  var headerHeight = 38 + 66 + 6; // 38 is search bar height
  // 66 is header bar height
  // 6 is space between header and element to get perfect view

  window.scrollTo({
    top: el.getBoundingClientRect().top + window.pageYOffset - headerHeight,
    behavior: "smooth"
  });
};

/***/ }),

/***/ 12453:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var getGAUserID = function getGAUserID() {
  try {
    var trackers = ga.getAll();
    var i, len;

    for (i = 0, len = trackers.length; i < len; i += 1) {
      if (trackers[i].get("trackingId") === "UA-186465270-2") {
        return trackers[i].get("clientId");
      }
    }
  } catch (e) {}

  return false;
};

/* harmony default export */ __webpack_exports__["Z"] = (getGAUserID);

/***/ }),

/***/ 92559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);



var sendData = /*#__PURE__*/function () {
  var _ref2 = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_ref) {
    var api, data, token, endpoint, headers, options, response;
    return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            api = _ref.api, data = _ref.data, token = _ref.token;
            endpoint = api;
            headers = {
              "Content-Type": "application/json",
              "captcha-response": token
            };
            options = {
              method: "POST",
              headers: headers,
              body: JSON.stringify(data)
            };
            _context.next = 6;
            return fetch(endpoint, options);

          case 6:
            response = _context.sent;
            _context.next = 9;
            return response.json();

          case 9:
            return _context.abrupt("return", _context.sent);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function sendData(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["Z"] = (sendData);

/***/ }),

/***/ 62951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ trigger; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function trigger(eventType, data, fullName) {
  var event = new CustomEvent(eventType, {
    detail: {
      dataForm: _objectSpread({
        fullname: fullName,
        email: data.email
      }, data),
      response: data
    }
  });

  try {
    document.dispatchEvent(event);
  } catch (error) {
    console.log(error);
  }
}

/***/ }),

/***/ 7778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ BiLoaderAlt; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function BiLoaderAlt(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 27476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ FaCheck; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaCheck(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 66865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j7": function() { return /* binding */ InputEmail; },
/* harmony export */   "oH": function() { return /* binding */ InputText; },
/* harmony export */   "Z6": function() { return /* binding */ InputPhone; },
/* harmony export */   "Jg": function() { return /* binding */ CheckBox; }
/* harmony export */ });
/* unused harmony export InputNumber */
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91164);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _excluded = ["name", "placeholder", "register", "errors", "requiredText"],
    _excluded2 = ["as", "name", "placeholder", "register", "errors", "requiredText"],
    _excluded3 = ["name", "placeholder", "register", "errors", "requiredText", "invalidText"],
    _excluded4 = ["name", "text", "register", "errors", "checkboxTextClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var InputEmail = function InputEmail(_ref) {
  var _errors$name, _errors$email;

  var name = _ref.name,
      placeholder = _ref.placeholder,
      register = _ref.register,
      errors = _ref.errors,
      requiredText = _ref.requiredText,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", _objectSpread(_objectSpread({
      type: "email"
    }, register(name ? name : "email", {
      required: {
        value: true,
        message: requiredText || "Email is required"
      },
      pattern: {
        // Value: /(^(?:[0-9]+[a-z]|[a-z]+[0-9]|[a-z])[a-z0-9._%+-]*)+@[a-z0-9.-]+\.[a-z]{2,}$/,
        value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
        message: "Invalid e-mail"
      }
    })), {}, {
      placeholder: placeholder || "Email*",
      pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
      className: "w-full border-0 border-b border-b-gray-300 p-2 text-bbc-gray placeholder-gray-300 focus:ring-0 ",
      autoComplete: "off"
    }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-left text-sm text-red-500",
      children: name ? (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message : (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.message
    })]
  });
}; // Text Field must be single word or multiple word space with "_"

var InputText = function InputText(_ref2) {
  var _errors$name2;

  var as = _ref2.as,
      name = _ref2.name,
      placeholder = _ref2.placeholder,
      register = _ref2.register,
      errors = _ref2.errors,
      requiredText = _ref2.requiredText,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref2, _excluded2);

  var CustomTag = as || "input";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomTag, _objectSpread(_objectSpread({
      type: "text"
    }, register(name, {
      required: {
        value: true,
        message: requiredText || "This field is required"
      }
    })), {}, {
      placeholder: placeholder,
      className: "invalid-textfield w-full border-0 border-b border-b-gray-300 p-2 text-bbc-gray placeholder-gray-300 focus:ring-0",
      autoComplete: "off"
    }, props)), errors[name] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-sm text-red-500",
      children: (_errors$name2 = errors[name]) === null || _errors$name2 === void 0 ? void 0 : _errors$name2.message
    })]
  });
};
var InputPhone = function InputPhone(_ref3) {
  var _errors$name3, _errors$phone_number;

  var name = _ref3.name,
      placeholder = _ref3.placeholder,
      register = _ref3.register,
      errors = _ref3.errors,
      requiredText = _ref3.requiredText,
      invalidText = _ref3.invalidText,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref3, _excluded3);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", _objectSpread(_objectSpread({
      type: "text"
    }, register(name || "phone_number", {
      required: {
        value: true,
        message: requiredText || "Phone number is required"
      },
      pattern: {
        value: /[0-9]+/,
        message: invalidText || "Invalid phone number"
      }
    })), {}, {
      placeholder: placeholder,
      pattern: "[0-9]+",
      className: "invalid-textfield w-full border-0 border-b border-b-gray-300 p-2 text-bbc-gray placeholder-gray-300 focus:ring-0",
      autoComplete: "off"
    }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-sm text-red-500",
      children: name ? (_errors$name3 = errors[name]) === null || _errors$name3 === void 0 ? void 0 : _errors$name3.message : (_errors$phone_number = errors.phone_number) === null || _errors$phone_number === void 0 ? void 0 : _errors$phone_number.message
    })]
  });
};
var InputNumber = function InputNumber(_ref4) {
  var numberValue = _ref4.numberValue,
      min = _ref4.min,
      max = _ref4.max,
      setNumberValue = _ref4.setNumberValue;

  var handleOnclickNumber = function handleOnclickNumber(number) {
    setNumberValue(number);
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "relative flex w-28 items-center lg:mb-6 lg:w-40",
      children: [/*#__PURE__*/_jsx("button", {
        className: "absolute left-2 w-5 lg:left-5 ",
        onClick: function onClick(event) {
          if (numberValue > min) {
            handleOnclickNumber(parseInt(numberValue, 10) - 1);
          }

          event.preventDefault();
        },
        children: "-"
      }), /*#__PURE__*/_jsx("button", {
        className: "absolute right-2 w-5 lg:right-5 ",
        onClick: function onClick(event) {
          if (numberValue < max) {
            handleOnclickNumber(parseInt(numberValue, 10) + 1);
          }

          event.preventDefault();
        },
        children: "+"
      }), /*#__PURE__*/_jsx("input", {
        className: "moz:appearance-none h-10 w-28 rounded-full border-zinc-200 text-center lg:w-40",
        type: "text",
        value: numberValue,
        onKeyPress: function onKeyPress(event) {
          if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
          }
        },
        min: min,
        onChange: function onChange(event) {
          event.preventDefault();
          var newValue = event.target.value;

          if (newValue === "") {
            setNumberValue("");
          } else if (newValue < min) {
            setNumberValue(min);
          } else if (newValue > max) {
            setNumberValue(max);
          } else {
            setNumberValue(newValue);
          }
        },
        onBlur: function onBlur() {
          if (numberValue < min) {
            setNumberValue(min);
          }
        }
      })]
    })
  });
};
var CheckBox = function CheckBox(_ref5) {
  var _errors$name4;

  var name = _ref5.name,
      text = _ref5.text,
      register = _ref5.register,
      errors = _ref5.errors,
      checkboxTextClassName = _ref5.checkboxTextClassName,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref5, _excluded4);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: "relative block pl-7",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", _objectSpread(_objectSpread({
        type: "checkbox"
      }, register(name, {})), {}, {
        className: "bbc-checkbox absolute left-1 top-1 cursor-pointer rounded border-bbc-silver bg-transparent focus:shadow-none focus:outline-none focus:ring-0"
      }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: checkboxTextClassName ? checkboxTextClassName : "",
        dangerouslySetInnerHTML: {
          __html: text
        }
      })]
    }), errors[name] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-sm text-red-500",
      children: (_errors$name4 = errors[name]) === null || _errors$name4 === void 0 ? void 0 : _errors$name4.message
    })]
  });
};

/***/ }),

/***/ 78762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34853);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1216);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ReCaptcha = function ReCaptcha(props, ref) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
      ref: ref,
      sitekey: "6LeJZ68UAAAAAJZ8jxdgylEXeWL8P9Ckv7CLtE6t",
      badge: "inline",
      size: "invisible"
    }, props))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(ReCaptcha));

/***/ }),

/***/ 85882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Toast; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56727);
/* harmony import */ var common_contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72713);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97464);
/* harmony import */ var _ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30852);
/* harmony import */ var _Icon_fa_FaTimes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11856);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14388);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);












var contentStatus = {
  success: {
    title: "Send Success",
    description: "We'll contact you all right away."
  },
  error: {
    title: "Send Error",
    description: "Please check your network connection and try again"
  }
};
var timer = null;

var RenderContent = function RenderContent(_ref) {
  var sendStatus = _ref.sendStatus,
      sendContent = _ref.sendContent,
      setIsOpen = _ref.setIsOpen;

  switch (sendStatus) {
    case "success":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: "/assets/icons/checked.png",
              width: 90,
              height: 92,
              alt: "icon success",
              className: "mb-6"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-brand-800",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-sm text-bbc-gray",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.description
          })]
        });
      }

    case "error":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/assets/icons/error.png",
            width: 90,
            height: 92,
            alt: "icon error",
            className: "mb-6"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-red-500",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-sm text-bbc-red-500",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.description
          })]
        });
      }

    case "confirm":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/assets/icons/warning.png",
            width: 98,
            height: 100,
            alt: "icon error",
            className: "mx-auto mb-6",
            wrapper: {
              className: "block"
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-brand-700",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: "flex justify-around",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              variant: "outline",
              btnTextColor: "text-bbc-red-300 hover:text-white",
              btnBorder: "border border-bbc-red-300 hover:border-bbc-red-400",
              btnColor: "bg-transparent hover:bg-bbc-red-400",
              othersClass: "w-28",
              onClick: function onClick() {
                setIsOpen(false);
              },
              children: "No"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              othersClass: "w-28",
              onClick: function onClick() {
                sendContent.onClick();
                setIsOpen(false);
              },
              children: "Yes"
            })]
          })]
        });
      }

    case "custom":
      {
        return sendContent.element;
      }

    default:
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "mb-6 text-2xl font-semibold text-bbc-red-600",
          children: contentStatus.error.title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-sm",
          children: contentStatus.error.description
        })]
      });
  }
};

function Toast(_ref2) {
  var children = _ref2.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      sendStatus = _useState2[0],
      setSendStatus = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      sendContent = _useState3[0],
      setSendContent = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      bgAlert = _useState4[0],
      setBgAlert = _useState4[1];
  /* Handle Event */


  var closeModal = function closeModal(otherAction) {
    setIsOpen(false);

    if (otherAction) {
      try {
        otherAction(); // eslint-disable-next-line no-empty
      } catch (error) {}
    }

    clearTimeout(timer);
    document.documentElement.removeAttribute("style");
  };

  var openAlert = /*#__PURE__*/function () {
    var _ref3 = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(time, status, content, otherAction) {
      var closeModalAfterTime;
      return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              closeModalAfterTime = function _closeModalAfterTime(timeToClose) {
                return new Promise(function (resolve) {
                  timer = setTimeout(function () {
                    closeModal(otherAction);
                    resolve("closed");
                  }, timeToClose);
                });
              };

              if (content) {
                setSendContent(content);
              } else {
                setSendContent(contentStatus[status]);
              }

              _context.t0 = status;
              _context.next = _context.t0 === "success" ? 5 : _context.t0 === "error" ? 7 : _context.t0 === "confirm" ? 9 : _context.t0 === "custom" ? 11 : 13;
              break;

            case 5:
              setBgAlert("from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 7:
              setBgAlert("from-[#dd3333] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 9:
              setBgAlert("from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 11:
              setBgAlert(sendContent.bgAlert || "from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 13:
              return _context.abrupt("break", 14);

            case 14:
              setSendStatus(status);
              setIsOpen(true);

              if (!time) {
                _context.next = 19;
                break;
              }

              _context.next = 19;
              return closeModalAfterTime(time);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function openAlert(_x, _x2, _x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  /* Effect */


  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(common_contexts__WEBPACK_IMPORTED_MODULE_2__/* .ToastContext.Provider */ .uL.Provider, {
    value: {
      openAlert: openAlert,
      setOpenAlert: setIsOpen
    },
    children: [children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition */ .uT, {
      show: isOpen,
      as: "div",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Dialog */ .Vq, {
        open: isOpen,
        as: "div",
        className: "fixed inset-0  overflow-y-auto",
        onClose: closeModal,
        style: {
          zIndex: 100
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "fixed inset-0 bg-black/30",
          "aria-hidden": "true"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "min-h-screen px-4 text-center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition.Child */ .uT.Child, {
            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Dialog.Overlay */ .Vq.Overlay, {
              className: "fixed inset-0 bg-slate-900 bg-opacity-70"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
            className: "inline-block h-screen align-middle",
            "aria-hidden": "true",
            children: "\u200B"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition.Child */ .uT.Child, {
            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 scale-95",
            enterTo: "opacity-100 scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 scale-100",
            leaveTo: "opacity-0 scale-95",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().ToastContent), " relative inline-flex w-full flex-col  justify-center border-2 bg-gradient-to-b px-7  py-28 text-center align-middle transition-all ").concat(bgAlert, " rounded-2xl shadow-xl"),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: "absolute top-6 right-4",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("button", {
                  type: "button",
                  className: "inline-flex justify-center rounded-full border-2 border-white p-1 text-xs  font-medium text-white transition-all  hover:border-bbc-red-300 hover:text-bbc-red-300 focus:outline-none ",
                  onClick: closeModal,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Icon_fa_FaTimes__WEBPACK_IMPORTED_MODULE_5__/* .FaTimes */ .a, {
                    size: 12
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: "relative ",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(RenderContent, {
                  sendContent: sendContent,
                  sendStatus: sendStatus,
                  setIsOpen: setIsOpen
                })
              })]
            })
          })]
        })]
      })
    })]
  });
}

/***/ }),

/***/ 99047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34853);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87536);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(56727);
/* harmony import */ var common_contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72713);
/* harmony import */ var common_fetch_getGAUserID__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(12453);
/* harmony import */ var common_fetch_post__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92559);
/* harmony import */ var common_trigger__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(62951);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Icon_bi_BiLoaderAlt__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7778);
/* harmony import */ var components_atoms_Icon_fa_FaTimes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11856);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(66865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














/** ========== */





var EbookModal = function EbookModal(props) {
  /* Variables Define */
  var show = props.show,
      onHide = props.onHide,
      imgLeft = props.imgLeft,
      imgRight = props.imgRight,
      triggerName = props.triggerName,
      contactFromId = props.contactFromId,
      apiLink = props.apiLink,
      haveCheckBox = props.haveCheckBox,
      checkedId = props.checkedId,
      unCheckId = props.unCheckId;

  var _useForm = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .useForm */ .cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      clearErrors = _useForm.clearErrors,
      _useForm$formState = _useForm.formState,
      isSubmitting = _useForm$formState.isSubmitting,
      errors = _useForm$formState.errors;

  var recaptchaRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(imgLeft || imgRight),
      checkImage = _useState[0];

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(common_contexts__WEBPACK_IMPORTED_MODULE_4__/* .ToastContext */ .uL),
      openAlert = _useContext.openAlert;
  /* Handle Event */


  var closeModal = function closeModal() {
    onHide();
    reset();
    clearErrors();
  };
  /* Effect */


  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    var getHash = window.location.hash || "";

    if (getHash.length > 0) {
      var _document$getElementB;

      (_document$getElementB = document.getElementById(getHash.replace("#", ""))) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.click();
    }
  }, []);

  var onSubmit = /*#__PURE__*/function () {
    var _ref = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
      var token, GAUserID, newData;
      return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return recaptchaRef.current.executeAsync();

            case 2:
              token = _context.sent;

              if (token) {
                GAUserID = (0,common_fetch_getGAUserID__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)();
                newData = _objectSpread({}, data);
                newData.client_id = GAUserID ? GAUserID : "";
                newData.website_id = "1";
                newData.contact_from_id = haveCheckBox ? data.contactFromId ? checkedId : unCheckId : contactFromId;
                document.getElementById("popup-content-panel").style.display = "none";
                (0,common_fetch_post__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                  api: "".concat("https://core.test-lp.bbcincorp.com", "/").concat(apiLink),
                  data: newData,
                  token: token
                }).then(function (res) {
                  if (res.state) {
                    (0,common_trigger__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("contact_form", data, triggerName);
                    openAlert(3000, "success");
                    setTimeout(function () {
                      closeModal();
                    }, 3000);
                  } else {
                    openAlert(3000, "error");
                    document.getElementById("popup-content-panel").style.display = "block";
                    console.log("error");
                  }
                })["catch"](function () {
                  openAlert(3000, "error");
                  document.getElementById("popup-content-panel").style.display = "block";
                  console.log("error");
                });
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.Fragment, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_16__/* .Transition */ .uT, {
      show: show,
      as: "div",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_16__/* .Dialog */ .Vq, {
        as: "div",
        className: "fixed inset-0 z-50 overflow-y-auto",
        onClose: closeModal,
        style: {
          zIndex: 51
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
          className: "min-h-screen px-4 text-center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_16__/* .Transition.Child */ .uT.Child, {
            as: react__WEBPACK_IMPORTED_MODULE_2__.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_16__/* .Dialog.Overlay */ .Vq.Overlay, {
              className: "fixed inset-0 bg-slate-900 bg-opacity-70"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
            className: "inline-block h-screen align-middle",
            "aria-hidden": "true",
            children: "\u200B"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_16__/* .Transition.Child */ .uT.Child, {
            as: react__WEBPACK_IMPORTED_MODULE_2__.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 scale-95",
            enterTo: "opacity-100 scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 scale-100",
            leaveTo: "opacity-0 scale-95",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
              id: "popup-content-panel",
              className: "relative inline-block w-full px-4 py-10 text-center ".concat(checkImage ? "my-8 md:px-10 md:py-16 md:text-left" : "max-w-[315px] ", "  transform overflow-hidden rounded-2xl bg-white align-middle shadow-xl transition-all"),
              style: {
                maxWidth: checkImage ? "920px" : "none"
              },
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                className: "absolute top-6 right-4  ".concat(checkImage ? "md:right-10" : ""),
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("button", {
                  type: "button",
                  className: "inline-flex justify-center rounded-md border border-transparent text-sm font-medium text-bbc-gray outline-none transition-all focus:outline-none",
                  onClick: closeModal,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Icon_fa_FaTimes__WEBPACK_IMPORTED_MODULE_8__/* .FaTimes */ .a, {
                    size: 16
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                className: "",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
                  className: "flex justify-between ".concat(imgLeft ? "flex-row" : "", " ").concat(imgRight ? "flex-row-reverse" : ""),
                  children: [checkImage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                    className: "relative hidden w-1/2 md:block ".concat(imgLeft ? "mr-10" : "", " ").concat(imgRight ? "ml-10" : ""),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                      src: checkImage,
                      width: props.imgWidth || 310,
                      height: props.imgHeight || 445,
                      className: "w-full  ",
                      wrapper: {
                        className: " w-full h-full  ".concat(imgLeft ? "border-r pr-10" : "", " ").concat(imgRight ? "border-l pl-10" : "")
                      },
                      alt: "ebook background"
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                    className: "w-full ".concat(checkImage ? "items-center md:flex md:w-1/2" : " md:w-full"),
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("form", {
                      onSubmit: handleSubmit(onSubmit),
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                        className: "mb-6 lg:mb-10",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_10__/* .InputText */ .oH, {
                          register: register,
                          errors: errors,
                          name: "name",
                          placeholder: "Name*"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                        className: "mb-6 lg:mb-10",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_10__/* .InputEmail */ .j7, {
                          register: register,
                          errors: errors
                        })
                      }), haveCheckBox && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("label", {
                        className: " mb-6 flex",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("input", _objectSpread(_objectSpread({
                          type: "checkbox"
                        }, register("contactFromId")), {}, {
                          className: "bbc-checkbox mr-2 mt-1"
                        })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("span", {
                          className: "inline-block text-left text-sm",
                          children: "I would like to receive more helpful insights into offshore company incorporation."
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        type: "submit",
                        disabled: isSubmitting,
                        othersClass: "relative",
                        style: {
                          width: 180
                        },
                        children: [isSubmitting && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Icon_bi_BiLoaderAlt__WEBPACK_IMPORTED_MODULE_7__/* .BiLoaderAlt */ .s, {
                          className: "absolute mr-2 animate-spin",
                          size: 24
                        }), "Get It Free"]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("em", {
                        className: "mt-6 block text-sm",
                        children: "Document will be sent to your email shortly after successful submission."
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
                        className: "mt-6 flex justify-center ".concat(checkImage ? "md:justify-start" : ""),
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                          ref: recaptchaRef,
                          sitekey: "6LeJZ68UAAAAAJZ8jxdgylEXeWL8P9Ckv7CLtE6t",
                          badge: "inline",
                          size: "invisible"
                        })
                      })]
                    })
                  })]
                })
              })]
            })
          })]
        })
      })
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (EbookModal);
EbookModal.defaultProps = {};
/** ========== */

/***/ }),

/***/ 19190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(159);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27597);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/** ========== */




var RefundGuarantee = function RefundGuarantee(_ref) {
  var props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _ref);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "flex flex-col items-center justify-center text-center lg:flex-row lg:text-left",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        src: "/assets/icons/refund-guarantee.svg",
        width: 80,
        height: 80
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
        className: "mt-4 lg:mt-0 lg:ml-4",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
          className: "text-lg font-semibold",
          children: "Refund Guarantee"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
          className: "text-base font-normal",
          children: "We refund your money in full for services that we cannot deliver."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("em", {
          className: "text-sm font-medium leading-6 text-bbc-brand-500 underline",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            href: "/refund-policy",
            target: "_blank",
            children: "Read our policy"
          })
        })]
      })]
    })
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (RefundGuarantee);
/** ========== */

/***/ }),

/***/ 78354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91164);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["title", "subTitle", "data", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


/** ========== */




var Component = function Component(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      data = _ref.data,
      children = _ref.children,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: "row gap-y-6 lg:justify-end lg:gap-y-10",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: "col-12 lg:col-4",
          children: children ? children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            as: "h2",
            className: "text-center font-semibold lg:text-left",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              className: "block text-bbc-40px text-bbc-brand-800",
              children: title
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              className: "mt-4 block text-2xl  leading-9 ".concat(subTitle && subTitle === "in 4 easy steps" ? "text-bbc-brand-600" : "text-bbc-brand-800"),
              children: subTitle
            })]
          })
        }), (data === null || data === void 0 ? void 0 : data.length) > 0 && data.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
            className: "col-12 lg:col-4",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
                className: "mb-6 flex items-center justify-center rounded-full bg-white text-lg font-semibold text-bbc-yellow-500",
                style: {
                  width: "58px",
                  height: "58px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)"
                },
                children: index + 1
              }), (item === null || item === void 0 ? void 0 : item.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                as: "h3",
                className: "mb-4 text-2xl font-medium text-bbc-brand-700 lg:mb-6 lg:font-semibold",
                children: item.title
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
                className: "leading-bbc-26 text-bbc-gray",
                dangerouslySetInnerHTML: {
                  __html: item.content
                }
              })]
            })
          }, index);
        })]
      })
    })
  }));
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);
Component.defaultProps = {
  data: []
};
/** ========== */

/***/ }),

/***/ 18691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91164);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88116);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98352);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9846);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85893);


var _excluded = ["className", "description", "imgAlt", "data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var StepSlider = function StepSlider(_ref) {
  var className = _ref.className,
      description = _ref.description,
      imgAlt = _ref.imgAlt,
      data = _ref.data,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
    className: " pt-10 lg:pt-24 ".concat(className),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
      className: "container",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        text: data.title,
        as: "h2",
        className: " mb-6 text-center text-3xl font-semibold capitalize text-bbc-brand-800 lg:mb-10 lg:text-4xl"
      }), description ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("p", {
        className: "mb-10 text-center",
        children: [" ", description]
      }) : null, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
        className: "row justify-center",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: "col-12 mb-6 flex items-center justify-center lg:col-4 lg:mb-0 lg:justify-start",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            src: "/assets/images/offshore/country/bvi/bank_account-bvi.png",
            alt: imgAlt,
            width: 351,
            height: 350
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: "col-12 order-3 flex items-center justify-center lg:col-1 lg:order-2",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            className: "swiper-pagination-custom flex h-6 items-end justify-center lg:h-[370px] lg:w-fit lg:flex-col lg:pr-4"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
          className: "col-12 order-2 self-center lg:col-6 lg:order-3 ",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, _objectSpread(_objectSpread({
              slidesPerView: 1,
              spaceBetween: 30,
              mousewheel: true,
              allowTouchMove: true,
              effect: "fade",
              fadeEffect: {
                crossFade: true
              },
              pagination: {
                el: ".swiper-pagination-custom",
                clickable: true,
                bulletClass: "pagination-bullet ",
                bulletActiveClass: "pagination-bullet-active bbc-pagination-bullet-active"
              },
              breakpoints: {
                320: {
                  allowTouchMove: true
                },
                1024: {
                  allowTouchMove: true
                }
              },
              modules: [swiper__WEBPACK_IMPORTED_MODULE_1__/* .Mousewheel */ .Gk, swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl, swiper__WEBPACK_IMPORTED_MODULE_1__/* .EffectFade */ .xW],
              className: "mySwiper"
            }, props), {}, {
              children: data.steps && data.steps.length > 0 && data.steps.map(function (step, index) {
                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                  className: "h-auto",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                    className: "step-slider h-full rounded-xl bg-transparent p-0 lg:bg-white lg:px-10 lg:pb-10 lg:pt-6",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                      as: "h3",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                        className: "mb-1 block text-lg font-medium text-bbc-brand-700",
                        children: step.index
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("span", {
                        className: "mb-6 block text-lg font-semibold text-bbc-brand-600 lg:text-2xl",
                        children: step.titleStep
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                      className: "text-bbc-gray",
                      dangerouslySetInnerHTML: {
                        __html: step.description
                      }
                    })]
                  })
                }, index);
              })
            }))
          })
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["default"] = (StepSlider);
StepSlider.defaultProps = {
  className: ""
};

/***/ }),

/***/ 10107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Icon_fa_FaCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27476);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31741);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47239);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var Card = function Card(_ref) {
  var title = _ref.title,
      price = _ref.price,
      listContent = _ref.listContent;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
    className: "mb-10 lg:col-6",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().cardWrapper)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        as: "h3",
        text: title,
        className: "text-center text-bbc-30px font-semibold text-bbc-brand-700",
        style: {
          marginBottom: "30px"
        }
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ul", {
        className: "mb-8",
        children: listContent.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("li", {
            className: "relative mb-2",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Icon_fa_FaCheck__WEBPACK_IMPORTED_MODULE_0__/* .FaCheck */ .l, {
              className: "absolute top-1.5 left-0 text-bbc-brand-500",
              size: 12
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
              className: "inline-block pl-7",
              children: item.text
            })]
          }, index);
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: "border-t border-t-bbc-neutral-300 pt-8 pb-4 text-center",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("p", {
          className: "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().price)),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
            children: "US$"
          }), price]
        })
      })]
    })
  });
};

var Component = function Component(_ref2) {
  var title = _ref2.title,
      data = _ref2.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      text: title,
      className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800 lg:mb-10 lg:text-bbc-40px"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: "m-auto lg:col-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        className: "row justify-around",
        children: data.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Card, {
            title: item.title,
            price: item.price,
            listContent: item.listContent
          }, index);
        })
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);

/***/ }),

/***/ 68422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/FormCountries/index.js
var FormCountries = __webpack_require__(88279);
// EXTERNAL MODULE: ./components/molecules/RefundGuarantee/index.js
var RefundGuarantee = __webpack_require__(19190);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/Faqs/index.js
var Faqs = __webpack_require__(37768);
// EXTERNAL MODULE: ./components/organisms/HowItWorks/index.js
var HowItWorks = __webpack_require__(78354);
// EXTERNAL MODULE: ./components/organisms/OffshoreCompanyRegistration/index.js
var OffshoreCompanyRegistration = __webpack_require__(58720);
// EXTERNAL MODULE: ./components/organisms/RequiredDocument/index.js
var RequiredDocument = __webpack_require__(95183);
// EXTERNAL MODULE: ./components/organisms/StepSlider/index.js
var StepSlider = __webpack_require__(18691);
// EXTERNAL MODULE: ./components/organisms/WhatMakeUsDifferent/index.js + 2 modules
var WhatMakeUsDifferent = __webpack_require__(58722);
// EXTERNAL MODULE: ./components/templates/vn/company-registration/BankingPackages/index.js
var BankingPackages = __webpack_require__(10107);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./common/action-function/scrollToBottomHeader.js
var scrollToBottomHeader = __webpack_require__(46259);
// EXTERNAL MODULE: ./components/molecules/TabListNew/index.js
var TabListNew = __webpack_require__(32144);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaCheck.js
var FaCheck = __webpack_require__(27476);
// EXTERNAL MODULE: ./components/atoms/Toast/index.js
var Toast = __webpack_require__(85882);
// EXTERNAL MODULE: ./components/molecules/EbookModal/index.js
var EbookModal = __webpack_require__(99047);
// EXTERNAL MODULE: ./components/molecules/CardPackage/Index.module.scss
var Index_module = __webpack_require__(67148);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/vn/company-registration/Packages/CardPackage/index.js





var PackageModal = (0,dynamic["default"])(function () {
  return __webpack_require__.e(/* import() */ 7258).then(__webpack_require__.bind(__webpack_require__, 87258));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(87258)];
    },
    modules: ["../components/templates/vn/company-registration/Packages/CardPackage/index.js -> " + "components/molecules/PackageModal"]
  }
});

/** ========== */




var ListContent = function ListContent(_ref) {
  var data = _ref.data,
      dataSuffix = _ref.dataSuffix;

  var _useState = (0,react.useState)(false),
      modalShow = _useState[0],
      setModalShow = _useState[1];

  var _useState2 = (0,react.useState)(false),
      ebookModalShow = _useState2[0],
      setEbookModalShow = _useState2[1];

  var showEbookBookModal = function showEbookBookModal(hash) {
    setEbookModalShow(true);

    if (history.pushState) {
      history.pushState(null, null, "#".concat(hash));
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "py-8 px-5",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "relative mt-2 flex pl-4 font-semibold before:absolute before:top-2 before:left-0 before:inline-block before:h-2 before:w-2 before:rounded-full before:bg-bbc-brand-500 before:content-[''] first:mt-0",
      dangerouslySetInnerHTML: {
        __html: data.subTitle
      }
    }), (data === null || data === void 0 ? void 0 : data.listContent) && (data === null || data === void 0 ? void 0 : data.listContent.length) > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
      className: "pl-0.5",
      children: data.listContent.map(function (content, key) {
        return content.checkName || content.ebook_download ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          children: [content.checkName && modalShow && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Toast/* default */.Z, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PackageModal, {
                country_name: dataSuffix.name,
                country_id: dataSuffix.id,
                show: modalShow,
                onHide: function onHide() {
                  return setModalShow(false);
                },
                suffix_data: dataSuffix.suffixData,
                isReserved: content.isReserved
              }), " "]
            })
          }), content.ebook_download && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Toast/* default */.Z, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(EbookModal["default"], {
                show: ebookModalShow,
                onHide: function onHide() {
                  return setEbookModalShow(false);
                },
                imgLeft: content.img_left_src || "",
                triggerName: content.trigger_name || "",
                apiLink: content.api_link || "",
                contactFromId: content.contact_from_id || null
              }), " "]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
            className: "relative mt-2 cursor-pointer",
            id: content.hash_id && content.hash_id,
            onClick: function onClick() {
              content.checkName ? setModalShow(true) : content.ebook_download && showEbookBookModal(content.hash_id);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
              className: "absolute top-1.5 left-0 text-bbc-brand-500",
              size: 12
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "inline-block pl-7 font-medium text-bbc-primary",
              dangerouslySetInnerHTML: {
                __html: content.text
              }
            }), content.childContent && content.childContent.map(function (item1, index1) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "inline-block pl-7 font-medium text-bbc-primary",
                  dangerouslySetInnerHTML: {
                    __html: item1
                  }
                })
              }, index1);
            })]
          }, key)]
        }, key) : /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: "relative mt-2",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(FaCheck/* FaCheck */.l, {
            className: "absolute top-1.5 left-0 text-bbc-brand-500",
            size: 12
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "inline-block pl-7",
            dangerouslySetInnerHTML: {
              __html: content.text
            }
          })]
        }, key);
      })
    })]
  });
};

var Component = function Component(_ref2) {
  var price = _ref2.price,
      data = _ref2.data,
      dataSuffix = _ref2.dataSuffix,
      index = _ref2.index,
      entityId = _ref2.entityId,
      dataPackage = _ref2.dataPackage;

  var getKindClass = function getKindClass() {
    if (index == 0) return "text-bbc-brand-500";
    if (index == 1) return "text-bbc-yellow-500";
  };

  var borderColorClass = function borderColorClass() {
    if (index == 0) return "lg:hover:border-bbc-brand-500";
    if (index == 1) return "lg:hover:border-bbc-yellow-500";
    if (index == 2) return "lg:hover:border-bbc-brand-700";
  };

  var btnColorClass = function btnColorClass() {
    if (index == 0) return "bg-bbc-brand-500  ".concat((Index_module_default()).btnBlue, " ");
    if (index == 1) return "bg-bbc-yellow-500  ".concat((Index_module_default()).btnYellow);
    if (index == 2) return "bg-bbc-brand-700 ".concat((Index_module_default()).btnDarkBlue);
  };

  var _useState3 = (0,react.useState)(0),
      Tab = _useState3[0],
      setTab = _useState3[1];

  var kind = data.kind,
      content = data.content,
      member = data.member,
      switchTab = data.switchTab;

  var SwitchOrganization = function SwitchOrganization() {
    setTab(0);
  };

  var SwitchIndividual = function SwitchIndividual() {
    setTab(1);
  };

  var dataLLC = dataPackage.Packages.filter(function (el) {
    return el.id == 65;
  });
  var priceLLC = dataLLC[0].Services[0].Fee.value;
  var dataJSC = dataPackage.Packages.filter(function (el) {
    return el.id == 79;
  });
  var priceJSC = dataJSC[0].Services[0].Fee.value;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "group flex h-full flex-col ".concat(switchTab ? "" : "justify-between", " rounded-3xl border-0  border-transparent bg-white ring-1 ring-neutral-200 transition-all duration-200 lg:border-4 lg:hover:border-4 ").concat(borderColorClass(), " lg:hover:shadow-[0px_16px_40px_rgba(181,181,181,0.25)]"),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "h-full",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "h-full pt-6",
        children: switchTab ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex h-full w-full flex-col justify-between",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                id: "left-tabs-example",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "mb-[10px]",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "m-auto flex max-w-fit justify-start rounded-full  border border-[#B7B7B7] border-opacity-70 md:border lg:justify-center",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                      className: "relative w-fit cursor-pointer select-none rounded-full py-2 px-4 text-sm font-semibold leading-6 text-bbc-brand-500 ".concat(Tab == 0 ? "border border-bbc-brand-500" : "border border-transparent text-bbc-neutral-600 hover:text-bbc-brand-500"),
                      onClick: SwitchOrganization,
                      children: "Organization"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                      className: "relative w-fit cursor-pointer select-none rounded-full py-2 px-4 text-sm font-semibold leading-6 text-bbc-brand-500 ".concat(Tab == 1 ? "border border-bbc-brand-500" : "border border-transparent text-bbc-neutral-600 hover:text-bbc-brand-500"),
                      onClick: SwitchIndividual,
                      children: "Individual"
                    })]
                  })
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                children: (content === null || content === void 0 ? void 0 : content.length) > 0 && (content === null || content === void 0 ? void 0 : content.map(function (item, index) {
                  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "".concat(Tab === index ? "none" : "hidden"),
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: " border-b  border-b-bbc-neutral-500 py-8 text-center",
                        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                          className: "text-[50px] font-semibold leading-[54px] tracking-[0.25px] text-bbc-primary",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            children: "US$"
                          }), price, member && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "text-base",
                            children: member
                          })]
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ListContent, {
                        data: item,
                        dataSuffix: dataSuffix
                      })]
                    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "".concat(Tab === index ? "hidden" : "none"),
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: " border-b  border-b-bbc-neutral-500 py-8 text-center",
                        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                          className: "text-[50px] font-semibold leading-[54px] tracking-[0.25px] text-bbc-primary",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            children: "US$"
                          }), data.id == 66 ? priceLLC : priceJSC, member && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                            className: "text-base",
                            children: member
                          })]
                        })
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ListContent, {
                        data: item,
                        dataSuffix: dataSuffix
                      })]
                    })]
                  }, index);
                }))
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "border-t border-t-bbc-neutral-500 px-5 pt-8 pb-11 text-center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "/onboarding/register?country_id=244&entity_type_id=".concat(entityId, "&package_id=").concat(Tab == 1 && data.id == 66 ? dataLLC[0].id : Tab == 1 && data.id == 80 ? dataJSC[0].id : data.id),
              className: " ".concat((Index_module_default()).btnAnimate, " ").concat(btnColorClass(), " inline-block w-full cursor-pointer  rounded-full border py-2 px-6 font-normal  text-white"),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "Get Started"
              })
            })
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex h-full flex-col justify-between",
          children: [(content === null || content === void 0 ? void 0 : content.length) > 0 && (content === null || content === void 0 ? void 0 : content.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: " border-b border-b-bbc-neutral-500 text-center ".concat(getKindClass(index)),
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "mb-[10px] text-[32px] font-semibold capitalize leading-[42px] tracking-[0.25px]",
                  children: kind
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                  className: "py-8 text-[50px] font-semibold leading-[54px] tracking-[0.25px]",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    children: "US$"
                  }), price]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(ListContent, {
                data: item,
                dataSuffix: dataSuffix
              })]
            }, index);
          })), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "border-t border-t-bbc-neutral-500 px-5 pt-8 pb-11 text-center",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "/onboarding/register?country_id=244&entity_type_id=".concat(entityId, "&package_id=").concat(data.id),
              className: "".concat((Index_module_default()).btnAnimate, " ").concat(btnColorClass(), " inline-block w-full  cursor-pointer rounded-full border py-2 px-6 font-medium text-bbc-white"),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: "Get Started"
              })
            })
          })]
        })
      })
    })
  });
};

/* harmony default export */ var CardPackage = (Component);
Component.defaultProps = {
  notes: [],
  content: [],
  index: 0
};
/** ========== */
;// CONCATENATED MODULE: ./components/templates/vn/company-registration/Packages/index.js






/** ========== */




var Packages_Component = function Component(_ref) {
  var _dataStaticEntitySuff, _data$entitySuffix, _data$entitySuffix$En;

  var data = _ref.data,
      dataStatic = _ref.dataStatic,
      title = _ref.title;

  var _useState = (0,react.useState)(0),
      defaultTab = _useState[0],
      setDefaultTab = _useState[1];

  var dataStaticPackage = dataStatic === null || dataStatic === void 0 ? void 0 : dataStatic.listPackage;
  var dataStaticEntitySuffix = dataStatic === null || dataStatic === void 0 ? void 0 : dataStatic.entitySuffix;
  var temp = dataStaticEntitySuffix === null || dataStaticEntitySuffix === void 0 ? void 0 : dataStaticEntitySuffix.reduce(function (totalID, currentValue) {
    totalID.push("".concat(currentValue.guid, "-package"));
    return totalID;
  }, []);

  var dataStaticFilter = function dataStaticFilter(id) {
    var result = dataStaticPackage.find(function (fruit) {
      return fruit.id == id;
    });
    return result;
  };

  var dataLink = "".concat((_dataStaticEntitySuff = dataStaticEntitySuffix[0]) === null || _dataStaticEntitySuff === void 0 ? void 0 : _dataStaticEntitySuff.guid, "-package");
  (0,react.useEffect)(function () {
    if (dataLink.length > 0) {
      var url = window.location.href;
      setDefaultTab(temp.indexOf(url.split("#")[1]) < 0 ? 0 : temp.indexOf(url.split("#")[1]));

      if (url.search("#".concat(url.split("#")[1])) > 0) {
        var scrollToTable = document.getElementById("PriceTable");
        (0,scrollToBottomHeader/* scrollToBottomHeader */.A)(scrollToTable);
      }
    }
  }, [temp, dataLink]);
  (0,react.useEffect)(function () {
    if (dataLink.length == 0) {
      setDefaultTab(0);
    }
  }, [dataLink]);
  var dataPackage = data.packages;
  var dataPackageFC = dataPackage.Packages.filter(function (el) {
    return el.id == 71 || el.id == 72;
  });
  var dataSuffixFC = data.entitySuffix.EntityTypes.filter(function (el) {
    return el.id == 14 || el.id == 15;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "min-h-screen pt-10 lg:pt-20",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
      text: title,
      className: "bbc-title text-center ".concat(dataStatic.description && dataStatic.description.length ? " mb-6" : " mb-6 lg:mb-10")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      id: "PriceTable",
      className: "mb-[60px] lg:mb-10",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TabListNew/* default */.Z, {
        data: dataStaticEntitySuffix.map(function (item) {
          return item.name;
        }),
        activeTab: defaultTab,
        tabLinks: dataStaticEntitySuffix.map(function (item) {
          return "".concat(item.guid, "-package");
        }),
        tabListClass: {
          display: "block lg:flex flex-wrap justify-center",
          border: "border-0 lg:border border-[#B7B7B7]",
          background: "bg-transparent lg:bg-white",
          othersClass: "whitespace-nowrap "
        },
        tabClass: {
          tabColor: "text-bbc-neutral-600 border-bbc-neutral-600 bg-white lg:border-transparent",
          tabColorActive: "text-bbc-brand-500 border-bbc-brand-500 bg-white",
          othersClass: "mx-auto my-1 lg:m-0"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panels */.OK.Panels, {
          className: "mt-6 w-full",
          children: data === null || data === void 0 ? void 0 : (_data$entitySuffix = data.entitySuffix) === null || _data$entitySuffix === void 0 ? void 0 : (_data$entitySuffix$En = _data$entitySuffix.EntityTypes) === null || _data$entitySuffix$En === void 0 ? void 0 : _data$entitySuffix$En.map(function (entity, indexEntity) {
            var _data$packages;

            var dataPackages = data === null || data === void 0 ? void 0 : (_data$packages = data.packages) === null || _data$packages === void 0 ? void 0 : _data$packages.Packages.filter(function (item) {
              return item.entity_type_id == entity.id;
            });
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(headlessui_esm/* Tab.Panel */.OK.Panel, {
              as: "div",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "hidden lg:block",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "row justify-center",
                  children: dataPackages.length === 3 ? dataPackages.filter(function (item) {
                    return item.id !== 65 && item.id !== 79;
                  }).map(function (card, index) {
                    var _card$PackageType, _data$entitySuffix2, _data$entitySuffix3;

                    var title = card === null || card === void 0 ? void 0 : (_card$PackageType = card.PackageType) === null || _card$PackageType === void 0 ? void 0 : _card$PackageType.name;
                    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "lg:col-5 xl:col-4",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardPackage, {
                        entityId: card.entity_type_id,
                        data: dataStaticFilter(card.id),
                        dataEntitySuffix: data.entitySuffix,
                        dataPackage: data.packages,
                        index: index,
                        kind: title,
                        price: card === null || card === void 0 ? void 0 : card.Services[0].Fee.value,
                        dataSuffix: {
                          id: 244,
                          name: data === null || data === void 0 ? void 0 : (_data$entitySuffix2 = data.entitySuffix) === null || _data$entitySuffix2 === void 0 ? void 0 : _data$entitySuffix2.sub_name,
                          suffixData: data === null || data === void 0 ? void 0 : (_data$entitySuffix3 = data.entitySuffix) === null || _data$entitySuffix3 === void 0 ? void 0 : _data$entitySuffix3.EntityTypes[indexEntity]
                        }
                      })
                    }, index);
                  }) : dataPackageFC.map(function (card, index) {
                    var _card$PackageType2, _data$entitySuffix4;

                    var title = card === null || card === void 0 ? void 0 : (_card$PackageType2 = card.PackageType) === null || _card$PackageType2 === void 0 ? void 0 : _card$PackageType2.name;
                    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "lg:col-5 xl:col-4",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardPackage, {
                        entityId: card.entity_type_id,
                        data: dataStaticFilter(card.id),
                        dataEntitySuffix: data.entitySuffix,
                        dataPackage: data.packages,
                        index: index,
                        kind: title,
                        price: card === null || card === void 0 ? void 0 : card.Services[0].Fee.value,
                        dataSuffix: {
                          id: 244,
                          name: data === null || data === void 0 ? void 0 : (_data$entitySuffix4 = data.entitySuffix) === null || _data$entitySuffix4 === void 0 ? void 0 : _data$entitySuffix4.sub_name,
                          suffixData: dataSuffixFC[index]
                        }
                      })
                    }, index);
                  })
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "block w-full lg:hidden",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(TabListNew/* default */.Z, {
                  data: dataStaticEntitySuffix[indexEntity] && dataStaticEntitySuffix[indexEntity].tabTitle.map(function (item) {
                    return item;
                  }),
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panels */.OK.Panels, {
                    className: "mx-auto mt-6 w-full max-w-[350px]",
                    children: dataPackages.length === 3 ? dataPackages.filter(function (item) {
                      return item.id !== 65 && item.id !== 79;
                    }).map(function (card, index) {
                      var _card$PackageType3, _data$entitySuffix5, _data$entitySuffix6;

                      var title = card === null || card === void 0 ? void 0 : (_card$PackageType3 = card.PackageType) === null || _card$PackageType3 === void 0 ? void 0 : _card$PackageType3.name;
                      return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panel */.OK.Panel, {
                        className: "focus:outline-none focus:outline-0 focus:ring-0",
                        as: "div",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardPackage, {
                          entityId: card.entity_type_id,
                          data: dataStaticFilter(card.id),
                          dataEntitySuffix: data.entitySuffix,
                          dataPackage: data.packages,
                          index: index,
                          kind: title,
                          price: card === null || card === void 0 ? void 0 : card.Services[0].Fee.value,
                          dataSuffix: {
                            id: 244,
                            name: data === null || data === void 0 ? void 0 : (_data$entitySuffix5 = data.entitySuffix) === null || _data$entitySuffix5 === void 0 ? void 0 : _data$entitySuffix5.sub_name,
                            suffixData: data === null || data === void 0 ? void 0 : (_data$entitySuffix6 = data.entitySuffix) === null || _data$entitySuffix6 === void 0 ? void 0 : _data$entitySuffix6.EntityTypes[indexEntity]
                          }
                        })
                      }, index);
                    }) : dataPackageFC.map(function (card, index) {
                      var _card$PackageType4, _data$entitySuffix7;

                      var title = card === null || card === void 0 ? void 0 : (_card$PackageType4 = card.PackageType) === null || _card$PackageType4 === void 0 ? void 0 : _card$PackageType4.name;
                      return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panel */.OK.Panel, {
                        className: "focus:outline-none focus:outline-0 focus:ring-0",
                        as: "div",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardPackage, {
                          entityId: card.entity_type_id,
                          data: dataStaticFilter(card.id),
                          dataEntitySuffix: data.entitySuffix,
                          dataPackage: data.packages,
                          index: index,
                          kind: title,
                          price: card === null || card === void 0 ? void 0 : card.Services[0].Fee.value,
                          dataSuffix: {
                            id: 244,
                            name: data === null || data === void 0 ? void 0 : (_data$entitySuffix7 = data.entitySuffix) === null || _data$entitySuffix7 === void 0 ? void 0 : _data$entitySuffix7.sub_name,
                            suffixData: dataSuffixFC[index]
                          }
                        })
                      }, index);
                    })
                  })
                })
              })]
            }, indexEntity);
          })
        })
      })
    })]
  });
};

/* harmony default export */ var Packages = (Packages_Component);
;// CONCATENATED MODULE: ./components/templates/vn/company-registration/index.js


















var NewsSlider = (0,dynamic["default"])(function () {
  return __webpack_require__.e(/* import() */ 5593).then(__webpack_require__.bind(__webpack_require__, 9485));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(9485)];
    },
    modules: ["../components/templates/vn/company-registration/index.js -> " + "components/organisms/NewsSlider"]
  }
});

var company_registration_Component = function Component(_ref) {
  var data = _ref.data,
      dataJson = _ref.dataJson;
  var country = dataJson.country;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
        minHeightBanner: "banner-min-h-635",
        breadcrumbs: dataJson.breadcrumbs,
        title: "Vietnam Company<br/>Registration",
        titleProps: {
          className: "banner-default-title mb-6 lg:mb-10",
          textColor: "banner-title-default-color"
        },
        leftClassName: "col-12 lg:col-7",
        rightClassName: "col-12 lg:col-5",
        rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/images/offshore/country/".concat(dataJson.banner_image),
          wrapper: {
            className: "bbc-banner-image-country pb-10 lg:pb-0"
          },
          className: "w-full ",
          width: 560,
          height: 456,
          priority: true,
          alt: "register a company in Vietnam"
        }),
        bgColor: "bg-bbc-country",
        dataTrustpilot: {
          dataStatic: dataJson.dataTrustpilot,
          dataDefault: data.dataTrustpilot
        }
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(OffshoreCompanyRegistration/* default */.Z, {
        data: dataJson.dataRegistration
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: dataJson.dataOpenBankAccount && typeof dataJson.dataOpenBankAccount === "object" && Object.keys(dataJson.dataOpenBankAccount).length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(StepSlider["default"], {
        description: "Foreign investors who want to set up a company in Vietnam will have to acquire two license types, namely the investment license and the enterprise license. Note that the licensing requirements can change depending on factors such as company ownership.",
        data: dataJson.dataOpenBankAccount,
        className: "pt-0 lg:pt-0",
        title: dataJson.dataOpenBankAccount.title,
        imgAlt: dataJson.dataOpenBankAccount.alt
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
      src: "/assets/images/wave/opposition-wave.png",
      width: 1920,
      height: 86,
      className: "w-full",
      wrapper: {
        className: "w-full"
      },
      alt: "Wave top"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "bg-bbc-brand-100",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Packages, {
          data: (data === null || data === void 0 ? void 0 : data.dataPackage) || [],
          dataStatic: dataJson.dataPackage,
          title: "Vietnam Company Formation Packages"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(BankingPackages/* default */.Z, {
          data: dataJson.dataBankingPackage,
          title: "Banking support package for Vietnam companies"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(RefundGuarantee/* default */.Z, {
          className: "mb-10 lg:mb-20"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row items-center pb-10 lg:pb-20",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "justify-self-start lg:col-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "h-full",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                text: "Bring your next business venture online",
                className: "bbc-title text-bbc-40px text-bbc-brand-800"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "lg:col-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "h-full",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("iframe", {
                  src: "https://www.youtube.com/embed/8RkJwKEXKPU?start=2",
                  width: "540",
                  height: "303",
                  frameBorder: "0",
                  title: "Bring your next business venture online",
                  allow: "accelerometer; autoplay;encrypted-media; gyroscope;picture-in-picture",
                  allowFullScreen: true,
                  className: " w-full"
                })
              })
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(WhatMakeUsDifferent/* default */.Z, {
          data: dataJson.dataWhatMakeUsDifferent,
          className: "bg-wmud py-[60px]"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(HowItWorks/* default */.Z, {
        title: "".concat(country, " Company Incorporation Process") // SubTitle="Company Incorporation Process"
        ,
        data: dataJson.dataHowItWorks,
        className: "py-10 lg:py-20"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(RequiredDocument/* default */.Z, {
        title: "Required Documents",
        data: dataJson.dataRequiredDocument,
        sectionClassName: "py-10 lg:py-20",
        backgroundImage: "/assets/images/common/required-documents.png"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      className: "relative",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: " absolute hidden h-1/2 w-full bg-bbc-brand-100 md:block"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container relative z-10 pt-10 lg:pt-20",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "m-auto lg:col-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormCountries/* default */.Z, {
            title: dataJson.dataFormContact.title,
            description: dataJson.dataFormContact.description,
            country_id: 244
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/wave/curve_bot-wave.svg",
        width: 1920,
        height: 86,
        className: "w-full",
        wrapper: {
          className: "absolute w-full top-1/2 hidden md:block"
        },
        alt: "Wave bottom"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "m-auto lg:col-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z, {
            data: dataJson.dataFaqs,
            title: dataJson.dataFaqs.title,
            description: dataJson.dataFaqs.description,
            defaultActiveKey: dataJson.dataFaqs.defaultActiveKey,
            multipleOpen: dataJson.dataFaqs.multipleOpen
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      className: "mb-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 m-auto mb-10 w-2/3 pb-0 text-center text-bbc-brand-800",
          children: "Industry News & Insights"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsSlider, {
            data: data
          })
        })]
      })
    })]
  });
};

/* harmony default export */ var company_registration = (company_registration_Component);
;// CONCATENATED MODULE: ./pages/vn/company-registration/data.json
var data_namespaceObject = JSON.parse('{"country":"Vietnam","banner_image":"banner-vn-registration.png","breadcrumbs":[{"title":"Home","uri":"/"},{"title":"Company Registration"}],"dataTrustpilot":{"content":{"button_placeholder":false,"benefits":["Free consulting on suitable corporate structure","Dedicated business support","No hidden fee/ transparent pricing"],"see_package":"See available package","see_package_id":"PriceTable"}},"dataOpenBankAccount":{"title":"Steps of registering your Vietnam company","description":"Foreign investors who want to set up a company in Vietnam will have to acquire two license types, namely the investment license and the enterprise license. Note that the licensing requirements can change depending on factors such as company ownership.","image":"/assets/images/offshore/country/bvi/bank_account-bvi.png","alt":"steps to set up a company in Vietnam","steps":[{"index":"Step 1: ","titleStep":"Investment Registration","description":"<p>The first step to start a business in Vietnam is to obtain an Investment Registration Certificate (IRC). This application is subject to the review and assessment by the Department of Planning and Investment.</p>"},{"index":"Step 2:","titleStep":"Enterprise Registration","description":"The next step is to get a Business/Enterprise Registration Certificate (ERC) from the provincial Department of Planning and Investment, regardless of whether the investment project is carried out inside or outside of the regulated zones. Typically, your ERC application will be processed within 3 working days. Note that depending on what sector your business operates in, additional licensing procedures may be required by relevant government ministry levels before obtaining approval."}]},"dataRegistration":{"country":"Why registering your company in Vietnam","data_left":["Strategic location at the heart of Southeast Asia region with well-equipped infrastructure for international trading","Flexible corporate structure with 100% Foreign Ownership (Wholly Foreign-Owned Enterprise), or Joint Venture with local partner","No initial paid-up capital requirement for most activities, but registered capital must be paid up in full within 90 days from the registration date.","Fast-growing domestic market with a total population of over 97 million people as of 2019 year-end, and high growth of middle class","Promising alternative manufacturing hub for China with competitive labor cost, young, dynamic, and resourceful local workforce","Socio-political and macro-economic stability","Transformation of centrally-managed to a market-oriented economy with many investment and tax incentives for foreign investors","15 Free trade agreements (FTAs) with its key trading partners. The most prominent among them are AFTA with Asian countries, EVFTA with European member states."],"data_right":[{"title":"Limited Liability Company (LLC) / Join Stock Company (JSC)","list_regulation":[{"title":"At least one member / 3 shareholders","icon":"user-switch.svg"},{"title":"Required local registered address","icon":"user-location.svg"},{"title":"No local legal representative requirement","icon":"bank-dolla.svg"},{"title":"No minimum capital requirement for most cases","icon":"wallet.svg"},{"title":"No upfront paid-up capital","icon":"doc-dollar.svg"}]}]},"dataPackage":{"entitySuffix":[{"id":11,"name":"Limited Liability Company (LLC)","tabTitle":["JVC","WOFE"],"guid":"llc"},{"id":13,"name":"Join Stock Company (JSC)","tabTitle":["JVC","WOFE"],"guid":"jsc"},{"id":14,"name":"Foreign Company","tabTitle":["BO","RO"],"guid":"bo"}],"listPackage":[{"id":66,"checkName":true,"ebook_download":true,"switchTab":true,"member":"/member","price":1099,"tabLinks":"Organization","content":[{"subTitle":"Establishment of a Joint Venture Company (FII)","listContent":[{"text":"Name availability check","checkName":true},{"text":"Business/Enterprise Registration Certificate (ERC)"},{"text":"Local registered address"},{"text":"Company seal"},{"text":"Public announcement of company registration"},{"text":"Tax registration after incorporation"}]}]},{"id":65,"checkName":true,"ebook_download":true,"switchTab":false,"tabLinks":"Individual","member":"/member","price":790,"content":[{"subTitle":"Establishment of a Joint Venture Company (FII)","listContent":[{"text":"Name availability check","checkName":true},{"text":"Business/Enterprise Registration Certificate (ERC)"},{"text":"Local registered address"},{"text":"Company seal"},{"text":"Public announcement of company registration"},{"text":"Tax registration after incorporation"}]}]},{"id":67,"kind":"POPULAR","suffix_name":"Limited Liability Company (LLC)","price":2399,"background":"Purple","content":[{"subTitle":"Establishment of a Wholly Foreign-Owned Enterprise:","listContent":[{"text":"Name availability check","checkName":true},{"text":"Business/Enterprise Registration Certificate (ERC)"},{"text":"Investment Registration Certificate (IRC)"},{"text":"Local registered address"},{"text":"Company seal"},{"text":"Public announcement of company registration"},{"text":"Tax registration after incorporation"}]}]},{"id":80,"checkName":true,"ebook_download":true,"switchTab":true,"member":"/member","price":1099,"tabLinks":"Organization","content":[{"subTitle":"Establishment of a Joint Venture Company (FII)","listContent":[{"text":"Name availability check","checkName":true},{"text":"Business/Enterprise Registration Certificate (ERC)"},{"text":"Local registered address"},{"text":"Company seal"},{"text":"Public announcement of company registration"},{"text":"Tax registration after incorporation"}]}]},{"id":79,"checkName":true,"ebook_download":true,"tabLinks":"Individual","member":"/member","switchTab":false,"price":790,"content":[{"subTitle":"Establishment of a Joint Venture Company (FII)","listContent":[{"text":"Name availability check","checkName":true},{"text":"Business/Enterprise Registration Certificate (ERC)"},{"text":"Local registered address"},{"text":"Company seal"},{"text":"Public announcement of company registration"},{"text":"Tax registration after incorporation"}]}]},{"id":81,"kind":"POPULAR","price":2199,"background":"Purple","checkName":true,"content":[{"subTitle":"Establishment of a Wholly Foreign-Owned Enterprise:","listContent":[{"text":"Name availability check","checkName":true},{"text":"Business/Enterprise Registration Certificate (ERC)"},{"text":"Investment Registration Certificate (IRC)"},{"text":"Local registered address"},{"text":"Company seal"},{"text":"Public announcement of company registration"},{"text":"Tax registration after incorporation"}]}]},{"id":71,"suffix_name":"Foreign Company","entity_id":14,"background":"Blue","checkName":true,"content":[{"subTitle":"Establishment of a Branch","listContent":[{"text":"Name availability check","checkName":true,"isReserved":true},{"text":"Branch Establishment Certificate"},{"text":"Local registered address"},{"text":"Company seal"},{"text":"Public announcement of company registration"},{"text":"Tax registration after incorporation"}]}],"notes":[]},{"id":72,"entity_id":15,"background":"DarkBlue","suffix_name":"Foreign Company","checkName":true,"content":[{"subTitle":"Establishment of a Representative Office","listContent":[{"text":"Name availability check","checkName":true,"isReserved":true},{"text":"Rep Office Establishment Certificate"},{"text":"Local registered address"},{"text":"Company seal"},{"text":"Public announcement of company registration"},{"text":"Tax registration after incorporation"}]}],"notes":[]}]},"dataBankingPackage":[{"title":"Basic Banking Support","price":299,"listContent":[{"text":"One-time fee for application of one bank"},{"text":"Consulting on the preparation of your chosen bank\'s required documents"},{"text":"Preparing certified translated corporate documents if needed"},{"text":"Making appointment with your chosen bank in the supported list"}]},{"title":"Premium Banking Support","price":599,"listContent":[{"text":"One-time fee for application of up to 3 banks OR till account opened successfully, whichever comes first"},{"text":"Consulting on the preparation of your chosen bank\'s required documents"},{"text":"Preparing certified translated corporate documents if needed"},{"text":"Meeting at registered office address for all applications"}]}],"dataWhatMakeUsDifferent":[{"title":"Streamlined process","description":"Start at your own pace. And reduce waiting time for back-and-forth email communication.","img_src":"/assets/images/common/process-wmud.png"},{"title":"E-signature","description":"Collaborate with your partner more easily. Less paperwork, more efficiency.","img_src":"/assets/images/common/e_signature-wmud.png"},{"title":"Digitized KYC","description":"Standardized form & organizational chart to let you control and declare your information effortlessly.","img_src":"/assets/images/common/kyc-wmud.png"},{"title":"Centralized management portal","description":"24/7 access to company documents on high-security cloud infrastructure. And no worry about key compliance deadlines with auto reminder.","img_src":"/assets/images/common/portal-wmud.png"}],"dataHowItWorks":[{"title":"Create online order","content":"Enter our online order platform for easy onboarding experience and tailor your orders. We have different packages of Vietnam company formation and additional services that suit your goals. During this process, we also provide free consulting to help you set up the right company structure per your need."},{"title":"Make payment","content":"Your settlement can be made online via Credit card, Debit Card. Bank wire transfer is also acceptable."},{"title":"Collect and Verify KYC documents","content":"After receiving your order and payment, our customer service will contact you on the same day to confirm the order information and gather the required documents for incorporation in Vietnam."},{"title":"Proceed the incorporation","content":"The foreign corporate registration in Vietnam could be finished in 10 days or span from 2 to 3 months contingent on your selected business entity types, business sectors, and project\'s scale."}],"dataRequiredDocument":{"note":"<a rel=\\"nofollow\\" target=\\"_blank\\" href=\\"/files/certified-true-copy-guide.pdf\\"><span class=\'text-bbc-secondary-300 font-medium\' style=\'text-decoration:underline\'>* See certified true copy guide</span></a>","content":[{"title":"","listContent":[{"text":"Notarized/Certified True copy of passport of all members","content":[]},{"text":"Personal bank account confirmation letter proving financial capacity for the investment project","content":[]},{"text":"We also provide true copy certification service for your personal identity documents as per your need.","content":[]}]}]},"dataFormContact":{"title":"Need more help to set up your business in Vietnam?","description":"Just get in touch with us. We typically response within 2 hrs."},"dataFaqs":{"activeTab":0,"description":" ","data":[{"name":"Incorporation","faqs":[{"name":"Can a foreigner register company in Vietnam?","content":"<p>Yes, foreigners can register company in Vietnam. You can select either direct or indirect foreign investments to start your business as foreigners.</p>"},{"name":"Does Vietnam allow 100% foreign ownership?","content":"<p>Yes, you can set up a 100% foreign-owned company in Vietnam in the form of a limited liability company (LLC) or a joint-stock company (JSC).</p><p>A Vietnam limited liability company can have a maximum of 50 members, and member\'s liability is limited to their capital. Meanwhile, you\'ll need at least three founding shareholders to form a joint-stock company.</p>"},{"name":"How long does it take to establish a Vietnam company?","content":"<p>It normally takes 2 to 3 months to set up a new company in Vietnam. This process comprises two main stages: applying for investment registration certificate (IRC) and Business registration certificate (BRC). The most time-consuming procedure lies within the application for IRC.</p>"},{"name":"How can I speed up the registration process?","content":"<p>There are two ways that can help you reduce the waiting time for doing business in Vietnam. In particular, you can invest in an existing Vietnam company or establish a local company through your trusted nominee. Through this way, you don’t have to register for IRC or BRC. Otherwise, you can consider setting up a local branch or a representative office, depending upon your business\'s needs.</p>"}]},{"name":"Compliance tasks","faqs":[{"name":"How do I get a business license in Vietnam?","content":"<p>To legally set up a company in Vietnam, you need to apply for:</p><ul><li>Investment registration certificate (IRC) with the licensing authority. Note that the licensing authorities to which investors send the IRC application can be different. The normal procedure may take more than 15 days.</li><li>Business registration certificate (BRC) from the provincial Department of Planning and Investment. An BRC application is normally processed in 3 working days.</li></ul>"},{"name":"Under which type of company can I incorporate in Vietnam?","content":"<p>Your company in Vietnam can be incorporated under two most common structures: (i) Limited Liability Company (LLC), or (ii) Joint Stock Company (JSC). An LLC is renowned for its simple structure, and is more suitable for small businesses. In contrast, if your business plan is rather large, and you intend to go for a public offering, a JSC would be your ideal fit.</p>"},{"name":"What things that need to be done annually to keep my company in good legal standing?","content":"<p>Annual compliance obligation varies according to business types. Below lines will show you a quick view of what a wholly-owned foreign company or a joint venture company with foreign ownership must abide by during a calendar year.</p><div><h2>• On a quarterly basis:</h2><p>Valued added tax declaration and payment<br/>Personal income tax (PIT) and Corporate income tax (CIT) declaration and payment</p></div><div><h2>• On an annual basis:</h2><p>Pay business license tax<br/>Perform audit on financial statements by an independent audit firm\\nFile final CIT and PIT return</p></div>"}]},{"name":"Taxation","faqs":[{"name":"What types of tax will a foreign company established in Vietnam be subject to?","content":"<p>There are varied tax duties depending on business sector, types of goods and services, and kinds of income that a company engages with during its course of business. In addition, Vietnam tax residents are subject to tax on worldwide income. Simply put, nearly all foreign companies formed in Vietnam will have to fulfil following basic tax duties:</p><ul><li>Corporate income tax</li><li>Value added tax or VAT</li><li>Property tax</li><li>Import and export taxes</li></ul><p>Tax year in Vietnam overlaps with a calendar year, spanning over a 12-month period.</p>"}]},{"name":"Corporate structure/capital","faqs":[{"name":"Can I establish Vietnam company with myself being the sole member and director?","content":"<p>Yes, a single member LLC can cater to such need. It only requires one member who can be the same director. Moreover, an LLC has separate legal entity, so your liability is limited to only the amount of contributed capital</p>"},{"name":"Are there any business sectors that a foreigner is prohibited to carry on or limited to specific number of shares owned?","content":"<p>There is a long list of business lines that foreigners are not allowed to conduct or constrained by percent of shares holding.</p><p>Some typical examples of prohibited activities include printing services, services of sending laborers to work abroad, notarization, etc. Likewise, foreign ownership is capped in some business sectors such as logistics, commodity exchange operation, etc.</p>"},{"name":"Is there a minimum capital requirement for some specific business activities in Vietnam?","content":"<p>Except for some highly regulated industries like finance, insurance, real estate, etc. There is no minimum capital requirement for company establishment in Vietnam.</p>"},{"name":"Is there requirement on minimum registered capital?","content":"<p>There is no minimum registered capital for almost all business activities. The usual capital is USD10,000. That said, some industries do require participants to have specific minimum registered capital (aka \\"legal capital\\"), namely insurance or securities company, travel service providers, education related businesses, real estate trading, and so forth.</p>"},{"name":"Are bearer shares allowed?","content":"<p>According to article 113 of Law on Enterprise 2014, classes of shares a company can issue comprise ordinary shares, preference shares in terms of voting right, dividend, redeemable, or other preference shares as stipulated in the charter of a company. Share certificates must also bear the name of holder, address and other details pertinent to that holder.</p><p>With that being said, a Vietnam company cannot issue bearer shares.</p>"}]},{"name":"Banking","faqs":[{"name":"Which bank is best for foreigners in Vietnam?","content":"<p>The banking scene in Vietnam has developed tremendously over the years, with traditional banking institutions constantly upgrading their infrastructure to adapt to a more digitalized landscape and neobanks showing up more often than ever. If you\'re a foreign ex-pat/entrepreneur, these are some of the most common banking options for you to enjoy.</p><ul><li>Vietcombank</li><li>BIDV</li><li>MB Bank</li><li>HSBC</li><li>Techcombank</li><li>Citibank</li><li>Standard Chartered</li></ul>"}]}]}}');
;// CONCATENATED MODULE: ./pages/vn/company-registration/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
    locationRouter: "vn",
    navLight: true,
    page: data.page,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(company_registration, {
      data: data,
      dataJson: data_namespaceObject
    })
  });
}

/***/ }),

/***/ 69212:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vn/company-registration",
      function () {
        return __webpack_require__(68422);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14388:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ToastContent":"Index_ToastContent__WZ1XO"};

/***/ }),

/***/ 67148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"btnAnimate":"Index_btnAnimate__9QWo4","btnBlue":"Index_btnBlue__R4E_L","btnYellow":"Index_btnYellow__dEMtU","btnDarkBlue":"Index_btnDarkBlue__bbUcz"};

/***/ }),

/***/ 47239:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardWrapper":"Index_cardWrapper__q92F_","price":"Index_price__3yVeZ"};

/***/ }),

/***/ 159:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,8352,4868,4090,9738,7447,9156,975,2888,179], function() { return __webpack_exec__(69212); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);